import styled from 'styled-components/macro'
import {
  commonModalContentStyle,
  gradientModalStyle,
  gradientModalHeaderStyle,
  gradientModalScrollbarStyle,
  orangeGradient,
  squircle,
} from 'src/global/helpers'

export const Modal = styled.div`
  ${gradientModalStyle(orangeGradient, '#ff7a50', 'translateY(-50%) translate(0, 12vh) scale(0.01)')}
`

export const Header = styled.div`
  ${gradientModalHeaderStyle}
  padding: 24px 24px 20px;

  .intro {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);
  }
`

export const ModalContent = styled.div`
  ${commonModalContentStyle}
  ${gradientModalScrollbarStyle}
  padding: 0 24px 24px;

  .section {
    margin-bottom: 14px;
    padding: 12px 16px 16px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.25);
    ${squircle(20)}
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);

    &:first-child {
      background: transparent;
      border: none;
      backdrop-filter: none;
      -webkit-backdrop-filter: none;
      padding: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }

    > *:last-child {
      margin-bottom: 0;
    }
  }

  .section h3 {
    margin: 0 0 8px;
    max-width: none;
    text-align: left;
    font-size: 18px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.3;
  }

  .section p {
    margin: 0 0 12px;
    font-size: 15px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);
  }

  .benefits {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .benefits li {
    position: relative;
    padding: 8px 0 8px 24px;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.95);

    &::before {
      content: '';
      position: absolute;
      left: 4px;
      top: 16px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #ffffff;
    }
  }

  .inline-link {
    color: #ffffff;
    font-weight: 700;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
    transition: opacity 0.2s ease;
  }

  .inline-link:hover {
    opacity: 0.85;
  }

  .screenshot {
    display: block;
    width: 100%;
    margin: 16px 0;
    ${squircle(12)}
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
  }

  .screenshot.narrow {
    width: 37.5%;
    margin: 16px auto;
  }

  .link-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.22);
    border: 1px solid rgba(255, 255, 255, 0.35);
    ${squircle(40)}
    font-size: 14px;
    font-weight: 600;
    color: #ffffff;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.35);
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .section .note {
    margin: 12px 0 16px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
    color: #ffffff;
    font-style: italic;
  }
`
